import {useState, useEffect, useContext} from 'react'
import {useFetch} from "../hooks/useFetch";
import {useMsg} from "../hooks/useMsg"
import {UpdateUserContext} from "../../App"
import {MathJax, MathJaxContext } from "better-react-mathjax";
import {Aff_question} from "./Aff_question"
import {Chargement} from "./Chargement"
import {Mode_classe} from "./Mode_classe"
import {niveaux} from "../config/Config"
import {MesquestionsModif} from "./MesquestionsModif"
import "./Mesquestions.css"

export function Mesquestions0 ({auth}) {

  const updateUsercontext = useContext(UpdateUserContext)

  const [niveau, setNiveau] = useState('')
  const [classe, setClasse] = useState({
    active: false,
    nom: '',
  })
  const [meslistes, setMeslistes] = useState({})
  const [activModif, setActivModif] = useState(false)
  const [titreAff, setTitreAff] = useState([])
  const [newTitreAff, setNewTitreAff] = useState({
    val:'',
    num:999,
    active:false,
  })
  const [listeactive, setlisteactive] = useState('')
  const [chargement, setChargement] = useState(false)
  const [mode_classe, setMode_classe] = useState({
    active:false,
    title_mes_listes:[]
  })


  const {msg, setMsg} = useMsg('')

  // ============= New ================

  const {data, fetchApi, errors} = useFetch([])
  const Mes_niveaux = []

  useEffect(()=>{
    fetchApi('api-questions', {...auth, action:'RecupMesNiveaux', niveau:'3e'})
    if (errors === 'err') {
      setMsg('Une erreur est survenue, veuillez recommencer.', 'alert danger', 'fadeout3')
    }
  },[]);


  niveaux.forEach((niv, k) => {
    if(data?.includes(niv.slug)) {Mes_niveaux.push({title:niv.title, slug:niv.slug})}
  })
    
  const handleChangeTitre = (e) => {
    fetch("https://maths-au-quotidien.fr/react-automaths/api-questions.php", {
      method: 'POST',
      body: JSON.stringify({...auth, newTitre:newTitreAff.val, id_serie:e.target.id, action:'modif_titre_ma_serie', niveau:'3e'})
    })
    .then(response => response.json())
    .then(data => {
      setMsg(data, 'success', 'fadeout3')
      setlisteactive('')
      updateListe(auth)
    })
    .catch(err => console.log(err))
  }

  const handleClick = (e) => {
    if(e.target.attributes.name?.nodeValue === 'mesquestions' || e.target.parentNode.attributes.name?.nodeValue === 'mesquestions'){
      listeactive === e.target.parentNode.id ? setlisteactive('') : setlisteactive(e.target.parentNode.id)
      setNewTitreAff({
        val:'',
        num:999,
        active:false,
      })
    } 
    else if(e.target.className === 'modif_titre_ma_serie'){
      
    }
    else if(e.target.className === 'mode_classe'){
      setMode_classe({...mode_classe, active:true, title_mes_listes:e.target.id})
      //window.location.href = '#choisir'
    }
  }

  const updateListe = (auth) => {
    fetch("https://maths-au-quotidien.fr/react-automaths/api-questions.php", {
      method: 'POST',
      body: JSON.stringify({...auth, action:'Mesquestions', niveau})
    })
    .then(response => response.json())
    .then(data => {
      //console.log(data)
      setMeslistes(data)
      setTitreAff(Object.keys(data))
      setChargement(false)
    })
    .catch(err => console.log(err))
  }

  const sendData = (auth, name) => {
    fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
      method: 'POST',
      body: JSON.stringify({...auth, niveau, classe:classe.nom})
    })
    .then(response => response.json())
    .then(data => {
      setMsg(data, 'success', 'fadeout3')
      updateListe(auth)
      setlisteactive('')
      updateUsercontext()
    })
    .catch(err => console.log(err))
  }

  const handleSubmit = (e) => {
    const name = e.target.attributes.name.nodeValue
    if(name === 'supprMesquestions'){
      let confirm = window.confirm("Voulez-vous vraiment supprimer cette série de vos questions ?");
      if (!confirm) {return}
      auth = {...auth, action:name, id:e.target.id}
    } else {
      const param = Object.keys(meslistes).filter(elt => elt.split('__')[0] === e.target.id)[0]
      auth = {...auth, action:'listeMesquestions', etoile:'0', id:e.target.id, nb_question:meslistes[param].length}
    }
    sendData(auth, name)
  }

	useEffect(()=>{
		if (niveau) {
      updateListe({...auth, niveau})
    }
	},[niveau, activModif]); // Fetch ==> Mesquestions

  useEffect(()=>{
    if(typeof window?.MathJax !== "undefined"){
      window.MathJax.typeset()
    }
  },[listeactive, mode_classe, newTitreAff, activModif]); // MathsJax ancien [meslistes, mode_classe]


  //console.log('titreAff : ', titreAff)
  //console.log('data : ', data)
  //console.log('Mes_niveaux : ', Mes_niveaux)

  //console.log('meslistes ', meslistes)
  //console.log({...auth, titre:mode_classe.title_mes_listes.split('__')[1].split(' (')[0], questions:meslistes[mode_classe.title_mes_listes]})
  //<Modal auth={{...auth, titre:mode_classe.title_mes_listes.split('__')[1].split(' (')[0], questions:meslistes[mode_classe.title_mes_listes]}} setShow_activite={setMode_classe} />
  return (
    mode_classe.active ? 
      <div className='modal active'>
          <div className="suppr_serie" onClick={e=>{
            setMode_classe(false)
            e.target.parentNode.classList.remove('active')
          }}></div>
        <Mode_classe auth={{...auth, titre:mode_classe.title_mes_listes.split('__')[1].split(' (')[0], questions:meslistes[mode_classe.title_mes_listes]}} setMode_classe={setMode_classe} />
      </div> :
    (!activModif ? 
      <div className='content max' style={{textAlign:'left'}}>
    	<h1>Mes séries de questions</h1>
      <br/><br/>
      <div><b>▸ Choisir un niveau :</b></div> <br/>
      {Mes_niveaux.map((niv,k) => 
        <span key={k}>
        <span className={'btn_param' + (niveau === niv.slug ? ' active' :'')} onClick={()=>{
            setNiveau(niv.slug)
            setChargement(true)
          }}>{niv.title}
        </span>
        {k === 5 && <br/>}
      </span>)}
      <br/>
      <br/>
        <br/>
        <MathJaxContext>
        </MathJaxContext>
        {msg ? <span dangerouslySetInnerHTML={{ __html:msg}}></span> : ''}
        {chargement ? <Chargement /> : 
          <div id='choisir'>
            {titreAff.map((e, k) => 
              <div key={k} id={e.split('__')[0]} name="mesquestions" className={'mesquestions' + (e.split('__')[0] === listeactive ? ' active' :'') } onClick={handleClick} >
                <h3 title={e.split('__').slice(1).join('\n').replace('('+niveau+') - ', '')}>{(newTitreAff.val && newTitreAff.num === k) ? newTitreAff.val : e.replace('2e devoir mêmes notions__', '').replace('3e devoir mêmes notions__', '').split('__')[1].replace('('+niveau+') - ', '')}</h3> 
                {newTitreAff.active ? 
                  <div className="modif_titre_ma_serie_cadre center" >
                    <input type="text" name="modif_serie" placeholder="Nouveau titre" value={newTitreAff.val} onChange={(e)=>{setNewTitreAff({...newTitreAff, val:e.target.value, num:k})}} /> &nbsp;
                    <input type="button" id={e.split('__')[0]} className="btn" value="Modifier" onClick={handleChangeTitre} />
                  </div> : ''}
                <br/>

                <div>
                  {
                    e.split('__')[0] === listeactive && 
                      <>
                      <div name="modif_titre_ma_serie" className="modif_titre_ma_serie" title="Mofdifier le titre de la série"  style={{cursor:'pointer'}} onClick={()=>setNewTitreAff({...newTitreAff, active:true})}>🖊</div>
                      <div name="modif_serie" title="modif_serie" className="modif_serie" id={e} onClick={()=>setActivModif(true)}></div>
                      </>
                  }
                  <div name="mode_classe" title="Mode classe" className="mode_classe" id={e} onClick={handleClick}></div>
                  <div name="supprMesquestions" title="Supprimer" id={e.split('__')[0]} className="suppr_serie" onClick={handleSubmit} ></div>
                </div>
                {meslistes[e].map((q, k0)=> 
                   <Aff_question key={k0} key_tab={'0'} question={q} tag={""} />
                  )}
                <br/>
                <br/>
                <div align="center">
                  <button className="btn standard" onClick={()=>setClasse({...classe, active:true})} >Envoyer à une classe</button>
                  <br/><br/>
                  {classe.active ? 
                  <>
                    {auth.classes.map((cl, k) => 
                        <span key={k} className={'btn_param'+(cl === classe.nom ? ' active' : '') } name="classe" onClick={(e)=>setClasse({...classe, nom:cl})} >{cl}</span>)}
                    <br/><br/>
                    {classe.nom ? <button name="listeMesquestions" id={e.split('__')[0]} className="btn standard" onClick={handleSubmit} >{'Envoyer cette série aux '+classe.nom}</button> :''}
                  </>
                  :''}
                </div>
              </div>)}
           </div>
          }
        {titreAff.length || !niveau || chargement ? '' : <div className='info'><br/>Vous n'avez pas encore de série de questions <br/>pour le niveau {niveau}.<br/><br/></div>}
    </div>
    : <MesquestionsModif liste={meslistes} id_serie={listeactive} niv_serie={niveau} setActivModif={setActivModif} auth={auth}/>
    )
  )
}